<template>
    <Spinner v-if="show"
             class="d-inline-block mr-1 mb-n1"
             :size="18"
             :line-fg-color="color"
             line-bg-color="transparent"
    />
</template>

<script>
import Spinner from "vue-simple-spinner";

export default {
    components: {Spinner},

    props: {
        show: Boolean,
        color: {
            type: String,
            default: '#fff'
        }
    }
}
</script>
